export default __webpack_public_path__ + "static/2024-img-articolo-novembre2-3144f750fd7bc0a74783f45649442966.jpg";